const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '\u0024',
  GBP: '£',
  EUR: '€',
  CAD: 'CA\u0024',
  AUD: 'A\u0024',
}

export function currencySymbol(currency: string) {
  return CURRENCY_SYMBOLS[currency] ?? `${currency} `
}

export function formatMoneyCents(cents: number, currency: string) {
  const sign = cents < 0 ? '-' : ''
  return `${sign}${currencySymbol(currency)}${(Math.abs(cents) / 100).toFixed(2)}`
}

export function parseMoneyCents(amount: string) {
  return Math.round(Number(amount.replace(/[^\d.-]/g, '')) * 100)
}
